import { FC, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import languageServiceFactory from "../../services/LanguageServiceImpl";
import DropdownArrowSVG from "../../custom-components/svg/DropdownArrowSVG";
import { useClickOutOfElement } from "../../custom-hooks/useClickOutOfElement";
import { Languages } from "../../domain/enums/LanguagesEnum";

const languageService = languageServiceFactory();

const HeaderLanguageChange: FC = () => {
    const { t } = useTranslation();
    const tooltipRef = useRef(null);
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    useClickOutOfElement(tooltipRef, () => setIsTooltipVisible(false));
    const handleChangeLanguage = (lang: Languages) => {
        languageService.setCurrentLang(lang);
        languageService.notifyListeners(lang);
        setIsTooltipVisible(false);
    };

    return (
        <div ref={tooltipRef} className="relative flex justify-center items-center tmin2:mr-9 tmax4:mr-0">
            <div
                onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                className="flex justify-center items-center cursor-pointer tmax2:mb-[30px]"
            >
                <span className="H16 mr-2">{t(`header.languages.${languageService.currentLang}`)}</span>
                <DropdownArrowSVG className="tmax4:w-4 tmax4:h-[8px]" />
            </div>
            <div
                className={`absolute top-10 z-30 w-[150px] h-[96px] py-4 px-6 rounded-[7px] bg-white border border-[#EDEDED] transition-all duration-300 ease-in-out 
                    ${
                        isTooltipVisible
                            ? "opacity-100 visible pointer-events-auto"
                            : "opacity-0 invisible pointer-events-none"
                    }`}
            >
                {languageService.langs.map((lang, index) => (
                    <p
                        className={`relative H16 text-black text-center w-[100px] h-[32px] ${
                            index === lang.length - 1 ? "" : "border-b border-textFaded"
                        } ${index !== 0 ? "mt-[12px]" : ""} hover:font-[600] cursor-pointer`}
                        onClick={() => handleChangeLanguage(lang)}
                        key={`p-language-selection-${lang}`}
                    >
                        {t(`header.languages.${lang}`)}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default HeaderLanguageChange;
